import React from 'react';

export const SearchResultsContext = React.createContext({
  searchId: undefined,
  pageStruct: undefined,
  input: undefined,
  searchSubmitParams: undefined,
  isPageStructLoading: false,
  isPageStructReceived: false,
  location: {},
});
